import React, {Fragment, Component} from 'react';
import CardGrid from '../common/card-grid/CardGrid';
import Card from '../common/card-grid/Card';
import NextPageButton from '../common/NextPageButton';
import CardGridUnit from '../common/card-grid/CardGridUnit';
import {
  Button,
  Wrapper,
  Container,
  Item,
  List,
  Input,
  Row,
  selectAll,
  selectNone,
  select,
  isSelected,
  getFilteredData,
} from '../settings/Select';
import {FILTER_NONE, FILTER_ALL} from '../../constants/filters';
import gql from 'graphql-tag';
import {Query} from 'react-apollo';
import {withApollo} from 'react-apollo';
import WORKPLACES from '../../constants/workplaces';
import Loading from './Loading';
import Error from './Error';

const workplaceSettingsQuery = gql`
  query workplaceSettings($input: SettingsQueryInput!) {
    workplaces {
      id
      name
    }
    settings(input: $input) {
      id
      workplaces {
        type
        ids
      }
    }
  }
`;

const WorkplacesSettingsContainer = props => (
  <Fragment>
    <CardGrid halign="center">
      <CardGridUnit size={1 / 3} height="100%">
        {props.children}
      </CardGridUnit>
    </CardGrid>
    <NextPageButton hide />
  </Fragment>
);

class WorkplacesSettings extends Component {
  state = {
    workplaces: '',
  };

  render() {
    const {favoriteId} = this.props;
    return (
      <WorkplacesSettingsContainer>
        <Query query={workplaceSettingsQuery} variables={{input: {favoriteId}}}>
          {({loading, error, data}) => {
            if (loading)
              return (
                <Card>
                  <Loading />
                </Card>
              );
            if (error) return <Error>{error.message}</Error>;
            const filteredData = getFilteredData(data.workplaces, this.state.workplaces);
            return (
              <Card>
                <Wrapper>
                  <Button
                    active={data.settings.workplaces.type === FILTER_ALL}
                    onClick={() => selectAll(this, data.workplaces, 'id', 'workplaces')}>
                    {WORKPLACES.find(t => t.key === FILTER_ALL).label}
                  </Button>
                  <Button
                    active={data.settings.workplaces.type === FILTER_NONE}
                    onClick={() => selectNone(this, data.workplaces, 'id', 'workplaces')}>
                    {WORKPLACES.find(t => t.key === FILTER_NONE).label}
                  </Button>
                </Wrapper>
                <Input
                  placeholder={'Search Workplaces'}
                  value={this.state.workplaces}
                  onChange={e => this.setState({workplaces: e.target.value})}
                />
                <Container>
                  <List
                    itemCount={filteredData.length}
                    renderItem={({index, style}) => (
                      <Row
                        style={style}
                        key={index}
                        onClick={() =>
                          select(
                            this,
                            data.settings.workplaces,
                            filteredData[index].id,
                            data.workplaces,
                            'id',
                            'workplaces'
                          )
                        }
                        selected={isSelected(data.settings.workplaces, filteredData[index].id)}>
                        <Item>{filteredData[index].name}</Item>
                      </Row>
                    )}
                  />
                </Container>
              </Card>
            );
          }}
        </Query>
      </WorkplacesSettingsContainer>
    );
  }
}

export default withApollo(WorkplacesSettings);
